<div class="checkout-steps">
    <div *ngFor="let step of stepList; let idx = index; trackBy: trackByFn" class="checkout-step"
         [class.passed]="isPassedStep(step)"
         [class.active]="isCurrentStep(step)"
         (click)="models.goStep(step)">
      <span>{{ idx + 1}}</span> {{ stepTitle(step) | customLocale }}</div>
</div>
